<template>
  <div>
    <a-modal
      v-model="show"
      @cancel="onCanel"
      sticky
      scrollable
      :mask="false"
      :footer="null"
      :closable="true"
      :z-index="1022"
      width="70%"
      :title="$t('previewPdf')"
    >
      <div class="demo-spin-article">
        <div id="container">
          <iframe :src="src" v-if="!loading"></iframe>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"> </Spin>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'pdfPreviewCard',
  props: ['value', 'employees', 'printer'],
  data() {
    return {
      show: false,
      loading: false,
      src: ''
    }
  },
  methods: {
    ...mapActions('humanResource/employee', ['previewPdfCard']),
    onCanel() {
      this.src = ''
      this.$emit('cancel')
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'EMPLOYEE PROFILES',
        desc: not.text
      })
    }
  },
  watch: {
    value: function(value) {
      if (value) {
        this.show = value
        this.loading = true
        this.previewPdfCard({
          employee_id_lists: this.employees,
          type: this.printer,
        })
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.notice({ type: 'error', text: error.message })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 90vh;
  background: black;
}
#container iframe {
  width: 100%;
  height: 90vh;
}
</style>
